var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 10.5,
    cy: 4.29803,
    r: 2.5,
    stroke: "#6E6E6E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25 13.548C7.08333 14.7147 6.5 16.1314 6.5 17.798C6.5 16.1314 5.91667 14.7147 4.75 13.548C3.58333 12.3814 2.16667 11.798 0.5 11.798C0.5 13.298 0.975 14.598 1.925 15.698C2.875 16.798 4.06667 17.4647 5.5 17.698V21.798H7.5V17.698C8.93333 17.4647 10.125 16.798 11.075 15.698C12.025 14.598 12.5 13.298 12.5 11.798C10.8333 11.798 9.41667 12.3814 8.25 13.548Z",
    fill: "#14AA3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.705 17.8878C11.8544 18.2709 12.0823 18.6228 12.3787 18.9192C12.9413 19.4818 13.7044 19.7979 14.5 19.7979C15.2956 19.7979 16.0587 19.4818 16.6213 18.9192C17.1839 18.3566 17.5 17.5935 17.5 16.7979H14.5L19.5 11.7979L19.5 16.7979C19.5 18.124 18.9732 19.3957 18.0355 20.3334C17.0979 21.2711 15.8261 21.7979 14.5 21.7979C13.1739 21.7979 11.9021 21.2711 10.9645 20.3334C10.5703 19.9393 10.2488 19.4861 10.0084 18.9947C10.6179 18.7035 11.1846 18.3338 11.705 17.8878ZM11.5 9.85491C10.8008 9.93596 10.1327 10.1035 9.5 10.3562L9.5 6.79803L11.5 6.79803V9.85491Z",
    fill: "#6E6E6E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario20);
export default __webpack_public_path__ + "static/media/Scenario20.24932fe1cd7a237203660653521aa5fe.svg";
export { ForwardRef as ReactComponent };